<template>
    <div class="signPayReturn">
        <el-result
            icon="success"
            title="支付成功"
        >
            <template slot="extra">
            </template>
        </el-result>
        <span class="title">请到OTE-A官网查看支付结果</span>
    </div>
</template>

<script>
export default {
    name: "signPayReturn",
    components: {},

    data() {
        return {};
    },
    created() {},

    destroyed() {},

    methods: {},
};
</script>

<style scoped>
.signPayReturn {
    width: 100%;
    padding-top: 12px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    align-items: center;
}
.title {
    font-size: 20px;
    font-weight: 700;
    color: #1778ff;
}
</style>
